const translations = {
    address1: 'Address Line 1',
    city: 'City',
    optional: '(Optional)',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
